import type { MountedPlayer } from './mediaPlayerTypes';

export type MediaLeaseHeartbeat = (playbackLeaseId: string) => Promise<{ expiresInSeconds?: number }>;

export function startMediaLeaseHeartbeat(media: MountedPlayer, heartbeat: MediaLeaseHeartbeat): void {
	if (!media.playbackLeaseId || media.heartbeatTimer !== undefined) return;
	const leaseId = media.playbackLeaseId;
	const intervalSeconds = Math.max(30, media.heartbeatIntervalSeconds ?? 120);
	media.heartbeatTimer = globalThis.setInterval(() => {
		void heartbeat(leaseId)
			.then((result) => {
				if (media.playbackLeaseId === leaseId && !media.releaseStarted && typeof result.expiresInSeconds === 'number' && result.expiresInSeconds > 0) {
					media.expiresAt = Date.now() / 1000 + result.expiresInSeconds;
				}
			})
			.catch(() => undefined);
	}, intervalSeconds * 1000) as unknown as number;
}

export function stopMediaLeaseHeartbeat(media: MountedPlayer): void {
	if (media.heartbeatTimer === undefined) return;
	clearInterval(media.heartbeatTimer);
	media.heartbeatTimer = undefined;
}

export function releaseMediaLeaseBestEffort(media: MountedPlayer): void {
	if (!media.playbackLeaseId || media.releaseStarted) return;
	media.releaseStarted = true;
	if (media.engagementStartRetryTimer !== undefined) clearTimeout(media.engagementStartRetryTimer);
	media.engagementStartRetryTimer = undefined;
	stopMediaLeaseHeartbeat(media);
	releaseMediaLeaseIdBestEffort(media.playbackLeaseId);
}

/**
 * Release an immutable lease id captured before a source handoff. Never read a
 * mutable MountedPlayer here: the same audio element can already represent the
 * next chapter by the time this request is sent.
 */
export function releaseMediaLeaseIdBestEffort(playbackLeaseId: string | undefined): void {
	if (!playbackLeaseId) return;
	void fetch('/api/media/lease/release', {
		method: 'POST',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify({ playbackLeaseId }),
		credentials: 'same-origin',
		keepalive: true,
	}).catch(() => undefined);
}
